module.exports = __webpack_public_path__ + "img/data1-3.8b0c3b22.png";